import tippy from 'tippy.js';

function ToolTip() {
  tippy('.tooltip', {
    content: 'website crafted by <b>adaptable.</b>'
  });
}

export default ToolTip;